import { render, staticRenderFns } from "./PowraE.vue?vue&type=template&id=2be90f25&scoped=true&"
import script from "./PowraE.vue?vue&type=script&lang=js&"
export * from "./PowraE.vue?vue&type=script&lang=js&"
import style0 from "./PowraE.vue?vue&type=style&index=0&id=2be90f25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be90f25",
  null
  
)

export default component.exports